<template>
  <v-modal
    id="tour-day-item-create"
    class-name="modal-fullscreen-sm-down"
    size="lg"
    @closed="$emit('closed')"
  >
    <modal-header class="justify-content-end pt-0"/>

    <modal-body class="pt-0">
      <div class="item-types-container w-100 row gx-8 gy-12">
        <div v-for="type in itemTypes" :key="type.key" class="item-type-container col-4">
          <a
            class="text-decoration-none d-flex flex-column align-items-center text-center p-8 rounded-xs hover-bg-light transition-all"
            href="#"
            @click.prevent="addItem(type.key)"
          >
            <div class="item-type-square service-tile-bg rounded-xs mb-8 shadow-sm">
              <v-icon :icon="type.icon" class="text-xl service-icon" :style="{ color: getServiceIconColor(type.key) }" />
            </div>

            <div class="item-type-info fw-bold text-dark text-xs lh-1 px-4" style="font-size: 10px;">{{ type.label }}</div>
          </a>
        </div>
      </div>
    </modal-body>
  </v-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { TYPE } from 'vue-toastification';
import VModal from '@/components/vendor/basic/modal/VModal.vue';
import ModalHeader from '@/components/vendor/basic/modal/ModalHeader.vue';
import ModalBody from '@/components/vendor/basic/modal/ModalBody.vue';
import useConcepts from '@/helpers/Concepts';
import { mapConcepts } from '@/helpers/ConceptHelper';
import VIcon from '@/components/vendor/basic/icon/VIcon.vue';
import api from '@/api';
import { getServiceIconColor as resolveServiceIconColor } from '@/helpers/ServiceIconColor';

export default defineComponent({
  name: 'TheTourDayItemCreateModal',
  components: {
    ModalBody,
    ModalHeader,
    VModal,
    VIcon,
  },
  emits: [
    'closed',
    'emitReloadTour',
    'openDetails',
  ],
  props: {
    agency: {
      type: String,
      required: true,
    },
    clientTourId: {
      type: Number,
      required: true,
    },
    tourId: {
      type: Number,
      required: true,
    },
    tourDayId: {
      type: Number,
      required: true,
    },
    version: {
      type: String,
      default: '',
    }
  },
  setup() {
    return {
      ...useConcepts(),
    };
  },
  data() {
    return {
      disableUnassignAgencyUserBtn: false as boolean,
    };
  },
  computed: {
    itemTypes(): any {
      if (!!this.concepts && this.concepts['supplier.type']) {
        return mapConcepts(this.concepts['supplier.type']);
      }

      return [];
    },
  },
  methods: {
    getServiceIconColor(type?: string) {
      return resolveServiceIconColor(type);
    },
    async addItem(type: string) {
      const loadingToast = this.$toast.loading(this.$t('general.button.adding'), 'toast-add-tour-day-item');
      let response: any;

      try {
        if(this.version === 'new') {
          response = await api.case.caseDayItemCreate(this.agency, this.tourId, this.tourDayId, {
            type
          });
        } else {
          response = await api.tourDayItem.create(
          this.agency,
          this.clientTourId,
          this.tourId,
          this.tourDayId,
          {
            type,
          },
        );
        }
        this.$emit('closed');
        this.$emit('openDetails', this.version === 'new' ? response.content : {
          id: response.id,
          tourDayId: response.tourDayId,
        });
        this.$emit('emitReloadTour');

        loadingToast.update('toast-add-tour-day-item', {
          content: this.$t('tourBuilder.dayItemCreated'),
          options: {
            type: TYPE.SUCCESS,
            icon: 'icon icon-check-circle-fill',
            timeout: 5000,
          },
        });
      } catch (e: any) {
        loadingToast.update('toast-add-tour-day-item', {
          content: this.$t('tourBuilder.dayITemCreateError'),
          options: {
            type: TYPE.ERROR,
            icon: 'icon icon-exclamation-triangle-fill',
            timeout: 5000,
          },
        });

        console.error(e.response.data);

        this.$toast.error(e.response.data.message);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
.item-types-container {
  .service-tile-bg {
    background-color: #f8f9fa;
  }

  .item-type-square {
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.5rem;
    width: 3rem;
    height: 3.5rem;
  }

  .hover-bg-light:hover {
    background-color: var(--uq-light);
    transform: translateY(-2px);
  }

  .transition-all {
    transition: all 0.2s ease-in-out;
  }
}

.service-icon {
  transition: color 0.2s ease;
}
</style>
